document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('TakuroaAdvertorial');
  if (!root) return;

  var cards = root.querySelectorAll('.price-card-adv');
  var cta = document.getElementById('TakuroaPriceCta');

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      cards.forEach(function (item) { item.classList.remove('selected-adv'); });
      card.classList.add('selected-adv');
      if (cta && card.dataset.link) cta.href = card.dataset.link;
    });
  });

  var selected = root.querySelector('.price-card-adv.selected-adv') || cards[0];
  if (selected && cta && selected.dataset.link) cta.href = selected.dataset.link;
});
